import { Component, ElementRef, OnDestroy, OnInit, QueryList, ViewChild, ViewChildren } from "@angular/core";
import { ActivatedRoute, Params, Router } from "@angular/router";
import { CustCard_3, ExecAnswer } from "src/classes/Customers/CustCard_3";
import { CustomerIn } from "src/classes/Customers/CustCard_1";
import { HttpServiceCustomer } from "src/app/services/Customer/http/http.service_Customer";
import { CustomCategory, IsCustomerPhone } from "src/classes/Customers/Customer";
import { SetValid } from "src/classes/Common/SetValid";
import { DynamiceditScreenComponent } from "src/app/Customers/dynamicedit-screen/dynamicedit-screen.component";
// import { City } from "src/classes/Common/City";
import { Config } from "src/classes/Common/ConfigData";
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { HttpClient, HttpHeaders } from "@angular/common/http";
import { BsDatepickerDirective } from "ngx-bootstrap/datepicker";
import { DynamicDialogRef, MessageService } from 'primeng/api';
import { DynamicDialogService } from "src/app/services/Customer/dynamic-dialog/dynamic-dialog.service";
import { NgForm, NgModel } from "@angular/forms";
import { NGXLogger } from "ngx-logger";
import * as moment from "moment";

interface Select {
    id: number;
    name: string;
}

interface SaparData {
    saparId: number;
    saparName: string;
}

@Component({
    selector: "app-custcard-editpersonal",
    templateUrl: "./custcard-editpersonal.component.html",
    styleUrls: ["./custcard-editpersonal.component.css"],
    providers: [HttpServiceCustomer, MessageService],
})

export class CustcardEditpersonalComponent implements OnInit, OnDestroy {
    id: number;
    isNewClient: boolean;

    custcard_3: CustCard_3 = new CustCard_3();
    customerin: CustomerIn = new CustomerIn();
    receivedvalid: SetValid = new SetValid();

    saveData: boolean = false;
    componentHasChanged: boolean = false;
    isDataSaving: boolean = false;

    customCategories: CustomCategory[];
    categoriesArray: CustomCategory[] = [];

    sexData: Select[] = [
        {
            id: 0,
            name: "בחר"
        },
        {
            id: 1,
            name: "לא מוגדר"
        },
        {
            id: 2,
            name: "אישה"
        },
        {
            id: 3,
            name: "גבר"
        }
    ];
    saparData: SaparData[];

    dynamicDialogRef: DynamicDialogRef;

    // phoneNumbersSet: string[];

    config: Config;

    allowedImageTypes: string[] = ["image/jpeg", "image/png", "image/svg+xml", "image/bmp"];
    isImageTypeErrorExist: boolean = false;
    // isImageSizeErrorExist: boolean = false;
    clientImage: File = null;
    clientImagePath: SafeResourceUrl;

    @ViewChildren(BsDatepickerDirective) datepickerModals: QueryList<BsDatepickerDirective>;
    @ViewChild("datepickerBirthday", { static: false }) datepickerBirthday: ElementRef<HTMLInputElement>;
    @ViewChild("datepickerWeeding", { static: false }) datepickerWeeding: ElementRef<HTMLInputElement>;

    maxDate: Date = new Date();
    minDate: Date = new Date(this.maxDate.getFullYear() - 100, this.maxDate.getMonth(), this.maxDate.getDate());

    isFormValid: boolean = true;

    @ViewChild("imageInput", { static: false }) imageInput: ElementRef<HTMLInputElement>;
    isImageInputFocused = false;

    url: string;

    isImageRemovingConfirmDialogVisible: boolean = false;
    isConfirmDialogVisible: boolean = false;
    confirmDialogText: string = "";

    isTagRemovingConfirmDialogVisible: boolean = false;
    removableId: number | null = null;

    messageVisibleTimeout: ReturnType<typeof setTimeout>;
    messageSummary: string;

    constructor(private router: Router,
        private activatedRoute: ActivatedRoute,
        private httpServiceCustomer: HttpServiceCustomer,
        private dynamicDialogService: DynamicDialogService,
        private sanitizer: DomSanitizer,
        private httpClient: HttpClient,
        private messageService: MessageService,
        private logger: NGXLogger
    ) {
        activatedRoute.params.subscribe((params: Params) => this.id = params["id"]);
        console.log("CustomerID: " + this.id);

        this.activatedRoute.queryParams.subscribe((params: Params) => this.isNewClient = params["isNewClient"]);
        this.url = this.router.url;
    }

    ngOnInit(): void {
        if (!this.id && !this.isNewClient) {
            this.router.navigate(["clients"]);
        }

        this.customerin.customer_id = this.id;

        //get custcard_3 data
        this.httpServiceCustomer.getCustCard_3(this.customerin)
            .subscribe((res: CustCard_3) => {
                this.custcard_3 = res;
                this.clientInit();

                this.getCategoriesArray();
                console.log(this.custcard_3)

                if (this.custcard_3.sourceID == 0) {
                    this.custcard_3.sourceName = "בחר";
                }

                if (this.custcard_3.cityID == 0) {
                    this.custcard_3.cityName = "בחר";
                }

                if (this.custcard_3.recommenderCustID == 0) {
                    this.custcard_3.recommenderfl = "בחר";
                }

                if (this.custcard_3.occupationId == 0) {
                    this.custcard_3.occupationName = "בחר";
                }

                if (!this.custcard_3.birthDay) {
                    this.custcard_3.birthDay = "";
                }

                if (!this.custcard_3.wedding_Date) {
                    this.custcard_3.wedding_Date = "";
                }

            }, error => {
                console.log(error);
                this.logger.error("user: " + sessionStorage.getItem("email") + ", component: " + this.constructor.name + ", error: " + error.message);
            });

        // get customCategories
        this.httpServiceCustomer.getCustomCategories()
            .subscribe((data: CustomCategory[]) => {
                this.customCategories = data;
                console.log("Count of customCategories:" + this.customCategories.length);
                this.getCategoriesArray();
            }, error => {
                console.log(error);
                this.logger.error("user: " + sessionStorage.getItem("email") + ", component: " + this.constructor.name + ", error: " + error.message);
            });

        // get config
        this.httpServiceCustomer.getConfig()
            .subscribe((data: Config) => {
                this.config = data;
                console.log("BusinessID:" + this.config.remotebusid);
            });

        // get workers
        this.httpServiceCustomer.getWorkers()
            .subscribe((data: SaparData[]) => {
                this.saparData = data;
            });
        console.log(this.custcard_3.birthDay);

        // this.phoneNumbersSet = JSON.parse(sessionStorage.getItem("phoneNumbersSet"));
    }

    ngOnDestroy(): void {
        this.dynamicDialogService.closeDialog();
    }

    clientInit(): void {
        this.custcard_3.sex = this.custcard_3.sex || 0;
        this.custcard_3.cityID = this.custcard_3.cityID || 0;
        this.custcard_3.recommenderCustID = this.custcard_3.recommenderCustID || 0;
        this.custcard_3.saparID = this.custcard_3.saparID || 0;
        this.custcard_3.sourceID = this.custcard_3.sourceID || 0;
        this.custcard_3.occupationId = this.custcard_3.occupationId || 0;
    }

    getClientImage(): string {
        return "https://optimusb12023.s3.eu-north-1.amazonaws.com/" + this.config.remotebusid + "/clients/" + this.custcard_3.customerId + "/" + this.custcard_3.imagePath;
    }

    getCategoriesArray(): void {
        if (this.custcard_3.idOfCategery && this.customCategories) {
            this.categoriesArray = this.customCategories.filter((category: CustomCategory) => {
                return this.custcard_3.idOfCategery.split(";").includes(category.custCategoryId.toString());
            });
        }
    }

    onScrollEvent(): void {
        this.datepickerBirthday.nativeElement.blur();
        this.datepickerWeeding.nativeElement.blur();
        this.datepickerModals.first.hide();
        this.datepickerModals.last.hide();
    }

    onImageLabelFocus(): void {
        this.imageInput.nativeElement.focus();
        this.isImageInputFocused = true;
    }

    onImageLabelBlur(): void {
        this.isImageInputFocused = false;
    }

    openTagRemovingConfirmDialog(id: number): void {
        this.removableId = id;
        this.isTagRemovingConfirmDialogVisible = true;
    }

    hideTagRemovingConfirmDialog(isSubmited: boolean): void {
        if (isSubmited) {
            let categoryToRemoveId: number = this.categoriesArray.findIndex((category: CustomCategory) => {
                return category.custCategoryId == this.removableId;
            });

            this.categoriesArray.splice(categoryToRemoveId, 1);
        }

        this.removableId = null;
        this.isTagRemovingConfirmDialogVisible = false;
    }

    uploadImage(event: Event) {
        const image = (event.currentTarget as HTMLInputElement).files[0];
        this.clientImage = new File(
            [image],
            Math.random().toString().substring(2, 8) + "." + image.name.split(".").pop(),
            {
                type: image.type,
                lastModified: image.lastModified
            }
        );

        // this.isImageSizeErrorExist = false;
        this.isImageTypeErrorExist = false;

        if (this.clientImage && this.allowedImageTypes.includes(this.clientImage.type)) {
            this.custcard_3.imagePath = this.clientImage.name;

            this.clientImagePath = this.sanitizer.bypassSecurityTrustResourceUrl(URL.createObjectURL(this.clientImage));

            // if (this.clientImage.size <= 400 * 1024) {
            //     this.clientImagePath = this.sanitizer.bypassSecurityTrustResourceUrl(URL.createObjectURL(this.clientImage));
            // }
            // else {
            //     this.clearImagePath();
            //     this.isImageSizeErrorExist = true;
            // }
        }
        else {
            this.clearImagePath();
            this.isImageTypeErrorExist = true;
        }
    }

    clearImagePath(): void {
        this.imageInput.nativeElement.value = "";
        this.clientImage = null;
        this.clientImagePath = null;
        this.custcard_3.imagePath = "";
        this.isImageTypeErrorExist = false;
        // this.isImageSizeErrorExist = false;
    }

    openImageRemovingConfirmDialog(): void {
        this.isImageRemovingConfirmDialogVisible = true;
    }

    hideImageRemovingConfirmDialog(isSubmited: boolean): void {
        if (isSubmited) {
            this.clearImagePath();
        }
        this.isImageRemovingConfirmDialogVisible = false;
    }

    isVIPCustomer(): boolean {
        if (this.categoriesArray && this.categoriesArray.find((item: CustomCategory) => item.custCategoryId == 7)) {
            return true;
        }
        return false;
    }

    toggleVip(): void {
        if (this.isVIPCustomer()) {
            this.categoriesArray.splice(this.categoriesArray.indexOf(this.categoriesArray.find((item: CustomCategory) => item.custCategoryId == 7)), 1);
        }
        else {
            this.categoriesArray.push(this.customCategories.find((item: CustomCategory) => item.custCategoryId == 7));
        }
    }

    showDynamicScreen(index: number): void {
        (document.activeElement as HTMLElement).blur();

        if (index == 1) {
            this.dynamicDialogRef = this.dynamicDialogService.openDialog(DynamiceditScreenComponent, {
                data: {
                    input_id: index, value: this.custcard_3.cityID,
                },
                header: "ישובים",
                styleClass: "modal"
            });

            this.dynamicDialogRef.onClose.subscribe((receivedObject: any) => {
                if (receivedObject && receivedObject.input_id === 1) {
                    if (receivedObject.option) {
                        this.custcard_3.cityID = receivedObject.value;
                        this.custcard_3.cityName = receivedObject.option;
                    }
                    else {
                        this.custcard_3.cityID = 0;
                        this.custcard_3.cityName = "בחר";
                    }
                }
            });
        }
        else if (index == 2) {
            this.dynamicDialogRef = this.dynamicDialogService.openDialog(DynamiceditScreenComponent, {
                data: {
                    input_id: index, value: this.categoriesArray,
                },
                header: "תיוגים",
                styleClass: "modal"
            });

            this.dynamicDialogRef.onClose.subscribe((receivedObject: any) => {
                if (receivedObject && receivedObject.input_id === 2) {
                    this.categoriesArray = [...receivedObject.value];
                }
            });
        }
        else if (index == 3) {
            this.dynamicDialogRef = this.dynamicDialogService.openDialog(DynamiceditScreenComponent, {
                data: {
                    input_id: index, value: { id: this.custcard_3.recommenderCustID, name: this.custcard_3.recommenderfl }
                },
                header: "לקוח ממליץ",
                styleClass: "modal"
            });

            this.dynamicDialogRef.onClose.subscribe((receivedObject: any) => {
                if (receivedObject && receivedObject.input_id === 3) {
                    console.log(receivedObject.value)
                    this.custcard_3.recommenderCustID = receivedObject.value.id;
                    this.custcard_3.recommenderfl = receivedObject.value.name;
                }
            });
        }
        else if (index == 4) {
            this.dynamicDialogRef = this.dynamicDialogService.openDialog(DynamiceditScreenComponent, {
                data: {
                    input_id: index, value: this.custcard_3.sourceID,
                },
                header: "מקורות הגעה",
                styleClass: "modal"
            });

            this.dynamicDialogRef.onClose.subscribe((receivedObject: any) => {
                if (receivedObject && receivedObject.input_id === 4) {
                    if (receivedObject.option) {
                        this.custcard_3.sourceID = receivedObject.value;
                        this.custcard_3.sourceName = receivedObject.option;
                    }
                    else {
                        this.custcard_3.sourceID = 0;
                        this.custcard_3.sourceName = "בחר";
                    }
                }
            });
        }
        else if (index == 5) {
            this.dynamicDialogRef = this.dynamicDialogService.openDialog(DynamiceditScreenComponent, {
                data: {
                    input_id: index, value: this.custcard_3.occupationId,
                },
                header: "תחום עיסוק",
                styleClass: "modal"
            });

            this.dynamicDialogRef.onClose.subscribe((receivedObject: any) => {
                if (receivedObject && receivedObject.input_id === 5) {
                    if (receivedObject.option) {
                        this.custcard_3.occupationId = receivedObject.value;
                        this.custcard_3.occupationName = receivedObject.option;
                    }
                    else {
                        this.custcard_3.occupationId = 0;
                        this.custcard_3.occupationName = "בחר";
                    }
                }
            });
        }
    }

    isInputInvalid(input: NgModel): boolean {
        return input.invalid && !this.isFormValid;
    }

    onPhoneInput(input: string, eventTarget: HTMLInputElement): void {
        if (input == "aditionalPhone") {
            if (this.custcard_3.aditionalPhone.length > 10) {
                this.custcard_3.aditionalPhone = this.custcard_3.aditionalPhone.slice(0, 10);
            }
            this.custcard_3.aditionalPhone = this.custcard_3.aditionalPhone.replace(/[^0-9]/g, "");
            eventTarget.value = this.custcard_3.aditionalPhone;
        }
        else if (input == "pelephone") {
            if (this.custcard_3.pelephone.length > 10) {
                this.custcard_3.pelephone = this.custcard_3.pelephone.slice(0, 10);
            }
            this.custcard_3.pelephone = this.custcard_3.pelephone.replace(/[^0-9]/g, "");
            eventTarget.value = this.custcard_3.pelephone;
        }
        else if (input == "phone") {
            if (this.custcard_3.phone.length > 10) {
                this.custcard_3.phone = this.custcard_3.phone.slice(0, 10);
            }
            this.custcard_3.phone = this.custcard_3.phone.replace(/[^0-9]/g, "");
            eventTarget.value = this.custcard_3.phone;
        }
    }

    submitForm(form: NgForm): void {
        if (form.valid) {
            this.custcard_3.firstName = this.custcard_3.firstName.trim();
            this.custcard_3.lastName = this.custcard_3.lastName ? this.custcard_3.lastName.trim() : "";
            this.custcard_3.address = this.custcard_3.address ? this.custcard_3.address.trim() : "";
            this.custcard_3.email = this.custcard_3.email ? this.custcard_3.email.trim() : "";

            this.isDataSaving = true;

            if (this.isNewClient) {
                // if (this.custcard_3.pelephone && Object.keys(this.phoneNumbersSet).includes(this.custcard_3.pelephone)) {
                //     this.confirmDialogText = "כבר קיים לקוח בשם " + this.phoneNumbersSet[this.custcard_3.pelephone] + " עם טלפון זהה מה ברצוני לעשות?";
                //     this.isConfirmDialogVisible = true;
                // }
                // else {
                //     this.saveDataCustCard3();
                // }
                if (this.custcard_3.pelephone) {
                    this.httpServiceCustomer.IsCustExistbyPhone({ phoneIn: this.custcard_3.pelephone })
                        .subscribe((response: IsCustomerPhone) => {
                            if (response.isExist) {
                                this.confirmDialogText = "כבר קיים לקוח בשם " + response.fl + " עם טלפון זהה מה ברצוני לעשות?";
                                this.isConfirmDialogVisible = true;
                            }
                            else {
                                this.saveDataCustCard3();
                            }
                        })
                }
                else {
                    this.saveDataCustCard3();
                }
            }
            else {
                this.saveDataCustCard3();
            }
        }
        else {
            this.isFormValid = false;
            this.isDataSaving = false;
        }
    }

    closeConfirmDialog(isAccepted: boolean): void {
        if (isAccepted) {
            this.saveDataCustCard3();
        }

        this.isDataSaving = false;
        this.isConfirmDialogVisible = false;
        this.confirmDialogText = "";
    }

    // set custcard_3 data
    saveDataCustCard3(): void {
        this.custcard_3.idOfCategery = this.categoriesArray.map((category: CustomCategory) => category.custCategoryId).join(";");

        if (!this.custcard_3.idOfCategery) {
            this.custcard_3.idOfCategery = "";
        }

        if (this.custcard_3.birthDay && typeof (this.custcard_3.birthDay) == "object") {
            (this.custcard_3.birthDay as Date).setHours(12);
            this.custcard_3.birthDay = moment(this.custcard_3.birthDay).format("DD/MM/YYYY");
        }

        if (this.custcard_3.wedding_Date && typeof (this.custcard_3.wedding_Date) == "object") {
            (this.custcard_3.wedding_Date as Date).setHours(12);
            this.custcard_3.wedding_Date = moment(this.custcard_3.wedding_Date).format("DD/MM/YYYY");
        }

        this.httpServiceCustomer.setCustCard_3(this.custcard_3)
            .then((result: ExecAnswer) => {
                console.log("CastCard_3 data saved: " + result.answer + "Max customerId: " + result.custIdMax);

                if (result.answer) {
                    const customerId: number = this.isNewClient ? result.custIdMax : this.customerin.customer_id;

                    if (this.clientImage) {
                        this.uploadImageToAWS(customerId)
                            .then((res) => {
                                this.isDataSaving = false;

                                if (this.isNewClient) {
                                    this.router.navigate(["clients", "custcardview", customerId], {
                                        queryParams: {
                                            isCreated: true
                                        }
                                    });
                                }
                                else {
                                    this.router.navigate(["clients", "custcardview", customerId], {
                                        queryParams: {
                                            isEdited: true
                                        }
                                    });
                                }
                            }, error => {
                                console.log(error);
                                this.logger.error("user: " + sessionStorage.getItem("email") + ", component: " + this.constructor.name + ", error: " + error.message);

                                this.isDataSaving = false;
                            });
                    }
                    else {
                        this.isDataSaving = false;

                        if (this.isNewClient) {
                            this.router.navigate(["clients", "custcardview", customerId], {
                                queryParams: {
                                    isCreated: true
                                }
                            });
                        }
                        else {
                            this.router.navigate(["clients", "custcardview", customerId], {
                                queryParams: {
                                    isEdited: true
                                }
                            });
                        }
                    }
                }
                else {
                    this.showMessage("error", "אופס... שמירת הפרטים נכשלה, נסו שוב או צרו קשר עם התמיכה");

                    this.isDataSaving = false;
                }
            }, error => {
                console.log(error);
                this.logger.error("user: " + sessionStorage.getItem("email") + ", component: " + this.constructor.name + ", error: " + error.message);

                this.isDataSaving = false;
            });

        this.saveData = true;
    }

    exitEditing(): void {
        if (this.isNewClient) {
            this.router.navigate(["clients"]);
        }
        else {
            this.router.navigate(["clients", "custcardview", this.customerin.customer_id]);
        }
    }

    async uploadImageToAWS(clientId: number): Promise<any> {
        const response: any = await this.httpClient.post(
            "https://12x2ym9xp9.execute-api.eu-north-1.amazonaws.com/v2/presign",
            {
                businessId: this.config.remotebusid,
                clientId: clientId,
                fileName: this.clientImage.name,
                contentType: this.clientImage.type
            }, {
            headers: new HttpHeaders({
                "Content-Type": "application/json"
            })
        }).toPromise();

        const presignedURL: string = JSON.parse(response.body).url;

        return this.httpClient.put(presignedURL, this.clientImage, {
            headers: new HttpHeaders({ "Content-Type": this.clientImage.type })
        }).toPromise();
    }

    showMessage(severity: string, summary: string): void {
        clearTimeout(this.messageVisibleTimeout);

        if (document.querySelector(".ui-messages") && this.messageSummary != summary) {
            this.messageService.clear();

            this.messageService.add({ severity, summary });
            this.messageSummary = summary;
            this.messageVisibleTimeout = setTimeout(() => {
                this.messageService.clear();
            }, 3500);
        }
        else {
            if (document.querySelector(".ui-messages")) {
                this.messageVisibleTimeout = setTimeout(() => {
                    this.messageService.clear();
                }, 3500);
            }
            else {
                this.messageService.add({ severity, summary });
                this.messageSummary = summary;
                this.messageVisibleTimeout = setTimeout(() => {
                    this.messageService.clear();
                }, 3500);
            }
        }
    }
}